import React from "react";
import _ from "lodash";
import { IoIosArrowDown } from "react-icons/io";
import PopupWrapper from "../../common/PopupWrapper";

class RequestTypeFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    this.child = React.createRef();
    this.handleClosePopover = this.handleClosePopover.bind(this);
  }

  handleClosePopover() {
    this.child.current.handleClosePopup();
  }

  render() {
    const {
      requestTypes,
      selectedRequestType,

      handleRequestTypeChanged,
    } = this.props;

    let selectorText = "";

    if (selectedRequestType === -1) {
      selectorText = <b>All Request Types</b>;
    } else {
      const reqTypeList = _.filter(requestTypes, (type) => {
        return _.indexOf(selectedRequestType, type) !== -1;
      }).join(", ");
      selectorText = (
        <span>
          Request Types(
          {selectedRequestType.length}): <b>{reqTypeList}</b>
        </span>
      );
    }

    return (
      <>
        <PopupWrapper
          ref={this.child}
          place="bottom left"
          triggerType="click"
          hideArrow={false}
          triggerElement={
            <button
              type="button"
              style={{
                maxWidth: "360px",
              }}
              className="border rounded hover:shadow focus:outline-none inline-flex cursor-pointer items-center border-gray-400 bg-white px-4 py-2 text-sm text-gray-700"
            >
              <span className="truncate mr-2">{selectorText}</span>
              <IoIosArrowDown></IoIosArrowDown>
            </button>
          }
          popupElement={
            <RequestTypeFilterPopup
              requestTypes={requestTypes}
              selectedRequestType={selectedRequestType}
              handleRequestTypeChanged={handleRequestTypeChanged}
              handleClosePopover={this.handleClosePopover}
            ></RequestTypeFilterPopup>
          }
        ></PopupWrapper>
      </>
    );
  }
}

class RequestTypeFilterPopup extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      requestTypes,
      selectedRequestType, // -1 or an array
    } = props;

    this.state = {
      requestTypeOptions: requestTypes,
      selectedRequestType,
    };

    this.handleRequestTypeSelected = this.handleRequestTypeSelected.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleApplyFilter = this.handleApplyFilter.bind(this);
  }

  handleRequestTypeSelected(requestTypeId) {
    if (requestTypeId === -1) {
      this.setState({
        selectedRequestType: requestTypeId,
      });
    } else {
      const { selectedRequestType } = this.state;
      this.setState({
        selectedRequestType: _.xor(
          selectedRequestType === -1 ? [] : selectedRequestType,
          [requestTypeId]
        ),
      });
    }
  }

  handleApplyFilter() {
    const { selectedRequestType } = this.state;
    this.props.handleRequestTypeChanged({
      selectedRequestType,
    });
    this.props.handleClosePopover();
  }

  handleCancel() {
    // close and nothing happened
    this.props.handleClosePopover();
  }

  render() {
    const { requestTypeOptions, selectedRequestType } = this.state;

    return (
      <>
        <div className="p-4 shadow-2xl" style={{ width: "600px" }}>
          <div className="flex">
            <div className="border-r mb-2 mr-3 border-gray-400 pr-3">
              <button
                type="button"
                className={`border rounded inline-flex cursor-pointer px-6 py-1 text-sm ${
                  selectedRequestType === -1
                    ? "bg-blue-600 text-white"
                    : "bg-white text-gray-800"
                } hover:border-blue-400`}
                onClick={() => this.handleRequestTypeSelected(-1)}
              >
                All
              </button>
            </div>

            <div
              className="flex flex-wrap"
              style={{ maxHeight: "160px", overflowY: "auto" }}
            >
              {requestTypeOptions.map((reqType) => {
                let btnClass =
                  "inline-flex border rounded px-3 py-1 text-sm mr-3 mb-2";
                if (
                  _.isArray(selectedRequestType) &&
                  _.indexOf(selectedRequestType, reqType) !== -1
                ) {
                  btnClass += " bg-blue-600 text-white";
                } else {
                  btnClass += " cursor-pointer hover:border-blue-400";
                }

                return (
                  <React.Fragment key={reqType}>
                    <button
                      type="button"
                      data-tip
                      data-for={`requestTypefilter-${reqType}`}
                      className={btnClass}
                      onClick={() => this.handleRequestTypeSelected(reqType)}
                    >
                      {reqType}
                    </button>
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          <div className="border-t flex justify-end pt-4">
            <button
              type="button"
              className="px-6 text-blue-500 hover:text-blue-600"
              onClick={this.handleCancel}
            >
              Cancel
            </button>

            <button
              type="button"
              className="rounded inline-flex justify-center bg-blue-500 px-10 py-2 text-sm text-white shadow-sm hover:bg-blue-600"
              onClick={this.handleApplyFilter}
            >
              Apply
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default RequestTypeFilter;
